<template>
  <div>

  </div>
</template>
<script>
  export default{
    name: 'message',
    methods: {
      msg(content) {
        this.$message({
          showClose: true,
          message: content
        });
      },

      success(content) {
        this.$message({
          showClose: true,
          message: content,
          type: 'success'
        });
      },
      warn(content) {
        this.$message({
          showClose: true,
          message: content,
          type: 'warning'
        });
      },

      error(content) {
        this.$message({
          showClose: true,
          message: content,
          type: 'error'
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Message.vue